import { View } from 'components/View'
import PropTypes from 'prop-types'
import React from 'react'
import getStyleComponentUtil from 'modules/component/utils/get-style'

function ModalFooter ({ children, style }) {
  return (
    <div
      style={getStyleComponentUtil({
        borderRadius: '0 0 0.27em 0.27em',
        borderTop: '0.055em solid #e6e6e6',
        padding: '0',
        position: 'relative',
        height: '2.77em'
      }, style)}
    >
      <View
        style={{
          height: '100%',
          flexDirection: View.DIRECTION.ROW,
          alignItems: View.ALIGN.CENTER
        }}
      >
        {children}
      </View>
    </div>
  )
}

ModalFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  style: PropTypes.object
}

ModalFooter.defaultProps = {
  style: {}
}

export default ModalFooter
